/**
 * Format seconds as MM:SS
 */
export function formatTime(seconds: number): string {
  const totalSeconds = Math.floor(seconds);
  const mins = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}

interface TimeColorPalette {
  success: string;
  warning: string;
  error: string;
}

/**
 * Get color based on remaining time:
 * - Green for > 10 minutes
 * - Orange/warning for 1-10 minutes
 * - Red for < 1 minute
 */
export function getTimeColor(
  timeLeftSeconds: number | null | undefined,
  palette: TimeColorPalette,
): string {
  const seconds = timeLeftSeconds ?? 0;
  if (seconds > 600) return palette.success;
  if (seconds > 60) return palette.warning;
  return palette.error;
}
